export const APP_VERSION = "3.0.0";

export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
  LIGHT: "LIGHT",
  DARK: "DARK",
};

export const TEXT_SCALES = {
  NORMAL: 1,
  LARGE: 1.125,
  XLARGE: 1.25,
};
